module.exports = __webpack_public_path__ + "img/confirmCardBg.ab023705.png";